// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","menu":"Footer_menu__CyDwl","menuButton":"Footer_menuButton__py-ly","copyRight":"Footer_copyRight__Hwf14","menuLink":"Footer_menuLink__QboIm"};